<div class="footer-wrapper">
  <div class="footer-wrapper-left">
    {{ copyright }}
  </div>
  <div class="footer-wrapper-right">
    <a *ngFor="let link of links" [href]="link.url">{{ link.label }}</a>
  </div>
</div>
